<template>
  <div
    class="anz-post-tooltip anz-bg-orange-light anz-py-s anz-pl-l anz-pr-s anz-b-rounded anz-flex anz-align-items-center"
  >
    <h6
      class="anz-fs-xs anz-align-center anz-font-default anz-ml-auto anz-mr-auto"
    >
      <slot name="text" />
    </h6>
    <a-button
      class-name="anz-link anz-color-beige anz-block anz-ml-s"
      @click="$emit('tooltip-close')"
      show-icon
      icon-width="0.7142em"
      icon-height="0.7142em"
      icon-name="cross-solid"
      icon-class="anz-block"
    />
  </div>
</template>

<script>
import AButton from '@/components/Forms/AButton'

export default {
  name: 'ASimpleTooltip',
  emits: ['tooltip-close'],
  components: { AButton },
}
</script>
